export const baseUrl = 'https://api.iris.message-chef.com/';
export const baseParams = {
	jsonrpc: '2.0',
	id: 3,
};
